import VisibilityState 	from 'javascripts/modules/visibility-state.js';

(function($) {
    $(function() {

    	$('.load-more').click(function(e){
    		e.preventDefault();
    		e.stopPropagation();
    	
    		var btn = $(this);
	        var containerBtn = $(btn).parents('.container-btn');
	        var pageCurrent = parseInt($(btn).data('page')) + 1 ;

	         var filters = $('.filters-layout input:checkbox:checked').map(function(){
      			return $(this).val();
    		}).get();

	 
	    
	    const data = {
				action: 'filter_posts',
				afp_nonce: afp_vars.afp_nonce,
				taxonomy :$(btn).data('taxonomy'),
				count : $(btn).data('count'),
				page : pageCurrent,
				filters : filters
			};

			$.ajax({
				type: 'post',
				url: afp_vars.afp_ajax_url,
				data: data,
				dataType : 'html',
				success: function( data, textStatus, XMLHttpRequest ) {
					$(containerBtn).before(data);

					if($.trim(data) != ''){
						$(btn).data('page',pageCurrent);	
					}else{
						$(btn).hide();
					}

					this.elements = document.querySelectorAll('[data-visibility]');
						const visibility    = new VisibilityState();
						visibility.refresh(this.elements);
					
				},
				error: function( MLHttpRequest, textStatus, errorThrown ) {
					console.log(textStatus);
				}
			});
		});
  });
})(jQuery);
